import useGenerateEstString from '@/hooks/useGenerateEstString';
import { selectedCountrySelector, selectedFlagSelector, selectedZipcodeSelector } from '@/redux/slice/preview.slice';
import { IRule } from '@/types/newSetup.type';
import parse from 'html-react-parser';
import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

interface IProps {
  ruleSelected?: IRule;
}

const PreviewSoldOut = ({ ruleSelected }: IProps) => {
  const generateEstString = useGenerateEstString();
  const countrySelected = useSelector(selectedCountrySelector);
  const flagSelected = useSelector(selectedFlagSelector);
  const zipcodeSelected = useSelector(selectedZipcodeSelector);

  const renderEstString = useMemo(() => {
    return generateEstString(
      ruleSelected?.soldOutCustomText || '',
      ruleSelected?.minPrepDays || 0,
      ruleSelected?.maxPrepDays || 0,
      ruleSelected?.minDeliveryDays || 0,
      ruleSelected?.maxDeliveryDays || 0,
      false,
      countrySelected,
      flagSelected,
      ruleSelected?.preOrderDate || '',
      ruleSelected?.isUsePreOrderDate,
      zipcodeSelected,
    );
  }, [
    countrySelected,
    flagSelected,
    generateEstString,
    ruleSelected?.isUsePreOrderDate,
    ruleSelected?.maxDeliveryDays,
    ruleSelected?.maxPrepDays,
    ruleSelected?.minDeliveryDays,
    ruleSelected?.minPrepDays,
    ruleSelected?.preOrderDate,
    ruleSelected?.soldOutCustomText,
    zipcodeSelected,
  ]);

  return (
    <>
      <div className="ot-estimated-shipping-basic-layout">
        <span className="ot-estimated-shipping-main-text">
          <span className="ot-estimated-shipping-main-text-estimated">{parse(renderEstString)}</span>
        </span>
      </div>
    </>
  );
};

export default memo(PreviewSoldOut);
